import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { MembersService } from '../services/members.service';

export function TeamNameUniqueAsyncValidator(membersService: MembersService): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    if (!control.value || !control.value.trim()) {
      return of(null);
    }

    return timer(400).pipe(
      switchMap(() =>
        membersService.checkTeamNameExists(control.value.trim()).pipe(
          map((result) =>
            result.exists ? { teamNameNotUnique: 'Team name must be unique' } : null
          ),
          catchError(() => of(null))
        )
      )
    );
  };
}
